import React, { useState, useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
// import { BsArrowRight, BsBriefcaseFill } from "react-icons/bs";
// import { AiFillHome } from "react-icons/ai";
// import { MdFamilyRestroom } from "react-icons/md";
import { BASE_URL, BASE_URL_POST } from "../../../constants/constants";
import ContractsCard from "@components/Cards/ContractsCard";
import CtaOne from "@components/CTA/CtaOne";
import { FiSearch } from "react-icons/fi";
import { ThreeDots } from "react-loader-spinner";
import { BsArrowRight } from "react-icons/bs";
import { CLMLinkPrimaryArrow } from "components/CLM/v3/Buttons";

const addHyphenInUrl = (str) => {
  return str.replace(/\s+/g, "-").toLowerCase();
};

export async function getServerSideProps(context) {
  const response = await fetch(`${BASE_URL}contracts-categories`);
  const data = await response.json();
  const { contractCategories } = data;
  // console.log(contractCategories);
  return {
    props: {
      categories: contractCategories,
    },
  };
}

const contractsCategories = [
  {
    image:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/contracts/family.png",
    iconBg: "bg-red-100/50",
    borderColor: "border-red-500",
    title: "Personal Family",
    description:
      "Essential agreements for family matters, from wills to custody arrangements.",
    contractsUrl: "/signature/contracts/personal-family",
  },
  {
    image:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/contracts/real-estate.png",
    iconBg: "bg-blue-100/50",
    borderColor: "border-blue-500",
    title: "Real Estate",
    description:
      "Key contracts for buying, selling, and managing property transactions.",
    contractsUrl: "/signature/contracts/real-estate",
  },
  {
    image:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/contracts/business.png",
    iconBg: "bg-yellow-100/50",
    borderColor: "border-yellow-500",
    title: "Business",
    description:
      "Comprehensive contracts for startups, partnerships, and corporate dealings.",
    contractsUrl: "/signature/contracts/business",
  },
];

const Contracts = ({ categories }) => {
  const [search, setSearch] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const handleSearch = async () => {
      // console.log("searching");
      setSearchLoading(true);
      const response = await fetch(`${BASE_URL_POST}search-contracts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ searchQuery: search }),
      });

      const data = await response.json();
      const { contracts } = data;

      setSearchResults(contracts);
      setSearchLoading(false);
    };

    let timer = setTimeout(() => {
      if (search.length > 0) {
        handleSearch();
      } else {
        setSearchResults([]);
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [search]);

  return (
    <div className="w-full md:mt-20 mt-8">
      <Head>
        <meta charSet="utf-8" />
        <title>Download Legal Teamplates from BoloSign</title>
        <meta
          name="description"
          content="Download free legal document templates like purchase agreements,
         NDAs, contracts and more. All templates are professionally 
         drafted by lawyers and can be easily customized."
        />

        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="BoloSign" />
        <meta name="publisher" content="BoloSign" />
        <meta name="keywords" content=" " />
        <meta
          property="og:url"
          content={`https://www.bolosign.com/signature/contracts/`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`Get all the Legal documents and use them as you like, download, modify and send for signing using BoloSign`}
        />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content={`https://www.bolosign.com/signature/contracts/`}
        />
        <meta
          name="twitter:title"
          content={`Get all the Legal documents and use them as you like, download, modify and send for signing using BoloSign`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@boloforms" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta name="twitter:description" content="" />
        <meta property="og:description" content="" />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/contracts/"
        />
      </Head>

      {/* <div className="flex flex-col text-center gap-7">
          <h1 className="text-5xl">Find Your Legal Forms</h1>
          <p className="text-xl">
            Create Your Free Legal Documents & Contracts Online in Minutes
          </p>
          <div className="flex flex-wrap justify-center items-center gap-8 mt-20">
            {categories.map((category, index) => (
              <Link
                key={index}
                href={`/signature/contracts/${addHyphenInUrl(category)}`}
                className="flex flex-col items-center justify-center gap-4 w-[200px] h-[200px] border-2 border-black rounded-xl px-2 py-5 hover:bg-gray-100 shadow-lg"
              >
                {
                  category === "Real Estate" ? <AiFillHome className="w-10 h-10 text-violet-700" /> :
                  category === "Personal Family" ? <MdFamilyRestroom className="w-10 h-10 text-violet-700" /> :
                  <BsBriefcaseFill className="w-10 h-10 text-violet-700" />
                } 
                <p className="text-lg font-semibold text-gray-600">
                  {category}
                </p>
                <BsArrowRight className="w-10 h-10 text-violet-700" />
              </Link>
            ))}
          </div>
        </div> */}
      <div className="w-full mb-20 max-w-screen-xl mx-auto flex flex-col gap-6 sm:gap-12 px-4 md:px-8 ">
        {/* heading section */}
        <div className="w-full max-w-screen-xl mx-auto text-center">
          <CtaOne heading2={`Find Your Legal Forms`} />
          {/* search bar  */}
          <div className="w-full max-w-screen-md mx-auto flex flex-col">
            <div className="flex justify-between items-center md:gap-2 w-full h-[50px] sm:h-[60px] p-2 rounded-lg bg-white border-[2px] border-gray-800">
              <div className="text-gray-800 text-3xl pl-3">
                <FiSearch />
              </div>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search for a document"
                className="h-full w-full px-3 md:flex-1 text-xl text-gray-800 placeholder-gray-800 outline-none border-none"
                name=""
                id=""
              />
              {searchLoading && (
                <div className="text-gray-400">
                  <ThreeDots
                    height="40"
                    width="50"
                    radius="9"
                    color="#a070f2"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              )}
            </div>
            {/* search results */}
            {searchResults.length > 0 && (
              <div className="border-2 rounded-lg bg-white mx-auto w-full mt-5 max-h-[480px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-corner-white scrollbar-track-transparent drop-shadow-xl ">
                {searchResults.map((contract, index) => (
                  <Link
                    key={index}
                    href={`/signature/contracts/${addHyphenInUrl(
                      contract?.categories
                    )}/${contract?.slug}`}
                    className="w-full group flex flex-col hover:bg-gray-50"
                  >
                    <div className="w-full text-left md:px-6 md:pt-6 px-4 pt-4">
                      <h2 className="text-gray-700 text-xl font-semibold leading-snug">
                        {contract?.name}
                      </h2>
                      <p className="font-normal text-base text-gray-700">
                        {contract?.description}
                      </p>
                    </div>
                    <div className="w-full flex justify-end items-center  pr-4 border-b border-gray-200 pb-4">
                      <CLMLinkPrimaryArrow
                        buttonText={"Create Document"}
                        buttonUrl={`/signature/contracts/${addHyphenInUrl(
                          contract?.categories
                        )}/${contract?.slug}`}
                      />
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
          {searchResults.length > 0 ? null : (
            <CtaOne
              paragraph={`Get all the Legal documents and use them as you like, download, modify and send for signing using BoloForms.`}
              paragraphStyling={`max-w-screen-sm mx-auto mt-8`}
            />
          )}
        </div>
        {/* contracts card  */}
        <div className="w-full h-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {contractsCategories.map((contract, index) => {
            return <ContractsCard key={index} {...contract} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Contracts;
